import { activity_recent, and, desc, eq, type PowerSyncDrizzleDB } from "@bodega/powersync";

const DEFAULT_FEED_LIMIT = 200;

/**
 * Local activity feed (PowerSync `activity_recent` bucket, ~90 days).
 * The account's SQLite only contains its buckets (personal scope + shared lists),
 * so there is no need to re-filter by user.
 * Canonical order: server_ts DESC (UUIDv7 id as tie-breaker).
 /** Waits for the app to finish booting (skeleton overlay disappears). */
export function getActivityFeedQuery(db: PowerSyncDrizzleDB, options: { limit?: number } = {}) {
  return db
    .select()
    .from(activity_recent)
    .orderBy(desc(activity_recent.server_ts), desc(activity_recent.id))
    .limit(options.limit ?? DEFAULT_FEED_LIMIT);
}

/**
 * Local history for a specific entity (for the detail's "History" sheet).
 * Deep history (beyond retention) is requested from the API
 * (`GET /api/activity/entity/:type/:id`).
 /** Waits for the app to finish booting (skeleton overlay disappears). */
export function getEntityActivityQuery(
  db: PowerSyncDrizzleDB,
  entityType: string,
  entityId: string,
  options: { limit?: number } = {},
) {
  return db
    .select()
    .from(activity_recent)
    .where(
      and(eq(activity_recent.entity_type, entityType), eq(activity_recent.entity_id, entityId)),
    )
    .orderBy(desc(activity_recent.server_ts), desc(activity_recent.id))
    .limit(options.limit ?? DEFAULT_FEED_LIMIT);
}
